const ElementOne = (props) => {
    return (
        <svg style={props.style ? props.style : {}} className={props.classNames} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            width="595.28px" height="841.89px" viewBox="0 0 595.28 841.89" enableBackground="new 0 0 595.28 841.89" xmlSpace="preserve">
            <path opacity={props.opacity ? props.opacity : '1'} fill={props.color} d="M0,0c0,169.927,546.531,228.131,551,398C555.651,574.828,0,665,0,841.89"/>
        </svg>
    )
}

export default ElementOne